import { DEFAULT_METRICS_FILTER_RANGE } from '@/hooks/use-metrics-filter-params';

export type OpeningDetailsPathParams = {
  dashboardPath: string;
  openingSlug: string;
  hasActiveHiringGoal: boolean;
  defaultMetricsPeriod?: number | string | null;
};

/**
 * Path to an opening's channels page. With an active hiring goal the URL
 * stays bare; otherwise `filter_range` is set to the org default (or
 * lifetime) so the page lands on date-range view.
 */
export function getOpeningDetailsPath({
  dashboardPath,
  openingSlug,
  hasActiveHiringGoal,
  defaultMetricsPeriod,
}: OpeningDetailsPathParams): string {
  const pathname = `${dashboardPath}/${openingSlug}/channels`;
  if (hasActiveHiringGoal) return pathname;

  const queryParams = new URLSearchParams();
  queryParams.set(
    'filter_range',
    defaultMetricsPeriod?.toString() ?? DEFAULT_METRICS_FILTER_RANGE,
  );
  return `${pathname}?${queryParams.toString()}`;
}
